import { render, staticRenderFns } from "./trilateralRecordDialog.vue?vue&type=template&id=70d27da8&scoped=true"
import script from "./trilateralRecordDialog.vue?vue&type=script&lang=js"
export * from "./trilateralRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./trilateralRecordDialog.vue?vue&type=style&index=0&id=70d27da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d27da8",
  null
  
)

export default component.exports